"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{Asset as s}from"./src/Asset.js";e("sp-asset",s);
//# sourceMappingURL=sp-asset.js.map
